import actionCreatorFactory from 'typescript-fsa';
import { WebUsage, WebUsageSummary } from '../../../services/account';
import { ServerType } from '../../System/systemConfig';

const actionCreator = actionCreatorFactory();

export const SYSADMIN_LOAD_WEB_USAGE = 'SYSADMIN_LOAD_WEB_USAGE';
export const sysadminLoadWebUsage = actionCreator<ServerType>(SYSADMIN_LOAD_WEB_USAGE);

export const SYSADMIN_LOAD_WEB_USAGE_DETAILS = 'SYSADMIN_LOAD_WEB_USAGE_DETAILS';
export const sysadminLoadWebUsageDetails = actionCreator<ServerType>(SYSADMIN_LOAD_WEB_USAGE_DETAILS);

export interface WebUsageLoadRequest {
    server: ServerType;
    usage: WebUsageSummary[];
}

export interface WebUsageDetailRequest {
    server: ServerType;
    usage: WebUsage[];
}
export const SYSADMIN_SET_WEB_USAGE = 'SYSADMIN_SET_WEB_USAGE';
export const sysadminSetWebUsage = actionCreator<WebUsageLoadRequest>(SYSADMIN_SET_WEB_USAGE);

export const SYSADMIN_SET_WEB_USAGE_DETAILS = 'SYSADMIN_SET_WEB_USAGE_DETAILS';
export const sysadminSetWebUsageDetails = actionCreator<WebUsageDetailRequest>(SYSADMIN_SET_WEB_USAGE_DETAILS);